import { atom, useAtom } from "jotai";

import { drawerOpenAtom } from "@theme/components";

import type { NavCategory } from "@theme/types";

export type DrawerView =
  | { type: "main" }
  | { type: "category"; category: NavCategory }
  | { type: "dropdown"; index: number }
  | { type: "account" };

export interface DrawerState {
  isOpen: boolean;
  currentView: DrawerView;
}

export interface DrawerActions {
  openDrawer: () => void;
  closeDrawer: () => void;
  showCategory: (category: NavCategory) => void;
  showMain: () => void;
  showDropdown: (index: number | { type: "account" }) => void;
}

const currentViewAtom = atom<DrawerView>({ type: "main" });

export const useDrawer = () => {
  const [isOpen, setIsOpen] = useAtom(drawerOpenAtom);
  const [currentView, setCurrentView] = useAtom(currentViewAtom);

  return [
    { isOpen, currentView },
    {
      openDrawer: () => setIsOpen(true),
      closeDrawer: () => {
        setIsOpen(false);
        setCurrentView({ type: "main" });
      },
      showCategory: (category: NavCategory) => setCurrentView({ type: "category", category }),
      showMain: () => setCurrentView({ type: "main" }),
      showDropdown: (index: number | { type: "account" }) => {
        if (typeof index === "number") {
          setCurrentView({ type: "dropdown", index });
        } else {
          setCurrentView({ type: "account" });
        }
      },
    },
  ] as const;
};
